import { render, staticRenderFns } from "./Chapter1.vue?vue&type=template&id=18706d5e&"
import script from "./Chapter1.vue?vue&type=script&lang=js&"
export * from "./Chapter1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports